import { render, staticRenderFns } from "./NCurrencyInput.vue?vue&type=template&id=3bc93c00&scoped=true&"
import script from "./NCurrencyInput.vue?vue&type=script&lang=js&"
export * from "./NCurrencyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc93c00",
  null
  
)

export default component.exports